// Objetivo: Definir os tipos de calculo de taxa de entrega
export const DeliveryFeeControll = {
  DISTANCE: 'D',
  STREET: 'R',
};
